import {
  OtpRequestSchema,
  SignInWithOtpRequestSchema,
  BackendSessionPayloadSchema,
} from '../../backend_schemas'
import { useNavigate, useSearchParams } from '@solidjs/router'
import { Component, createEffect, createSignal, DEV, Show } from 'solid-js'
import { parse } from 'valibot'
import { authAxios } from '../../axios'
import AlertBag from '../../components/AlertBag'
import Loader from '../../components/Loader'
import { updateAuthProfileValue } from '../../rx/shared/profile/authProfileValue'
import { updateSessionValue } from '../../rx/shared/session/sessionValue'
import { createAlertBagStore, setAlertBagError } from '../../rx/store/AlertBag'

const SignInPage: Component = () => {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const [otpToken, setOtpToken] = createSignal<string | null>(null)
  const [email, setEmail] = createSignal<string>('')
  const [otp, setOtp] = createSignal<string>('')
  const [isLoading, setIsLoading] = createSignal<boolean>(false)
  const alertBag = createAlertBagStore()

  createEffect(() => {
    const emailParam = params.email
    if (emailParam) {
      setEmail(Array.isArray(emailParam) ? emailParam[0] : emailParam)
    }
  })

  const handleSendOtp = async (e: Event) => {
    e.preventDefault()
    setIsLoading(true)
    setAlertBagError(alertBag, null)
    try {
      const payload = parse(OtpRequestSchema, { email: email() })
      const response = await authAxios.post('/otp', payload)
      setOtpToken(response.data.token)
      if (DEV && response.data.debug_otp) {
        setOtp(response.data.debug_otp)
      }
    } catch (err) {
      setAlertBagError(alertBag, err as Error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleSignIn = async (e: Event) => {
    e.preventDefault()
    setIsLoading(true)
    setAlertBagError(alertBag, null)
    try {
      const payload = parse(SignInWithOtpRequestSchema, {
        token: otpToken(),
        otp: otp(),
      })
      const response = await authAxios.post('/signin', payload)
      const session = parse(BackendSessionPayloadSchema, response.data.session)
      updateSessionValue(session)
      updateAuthProfileValue(response.data.profile)
      navigate('/')
    } catch (err) {
      setAlertBagError(alertBag, err as Error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div class="container mt-5">
      <div class="row justify-content-center">
        <div class="col-md-6">
          <div class="card shadow">
            <div class="card-body">
              <h2 class="card-title text-center mb-4">Sign In</h2>
              <AlertBag store={alertBag} />
              <Show when={!otpToken()} fallback={
                <form onSubmit={handleSignIn}>
                  <div class="mb-3">
                    <label class="form-label">Enter OTP sent to {email()}</label>
                    <input
                      type="text"
                      class="form-control form-control-lg text-center"
                      style={{ "letter-spacing": "0.5rem", "font-weight": "bold" }}
                      value={otp()}
                      onInput={(e) => setOtp(e.currentTarget.value)}
                      disabled={isLoading()}
                      required
                    />
                  </div>
                  <button type="submit" class="btn btn-primary w-100" disabled={isLoading()}>
                    {isLoading() ? <Loader /> : 'Sign In'}
                  </button>
                  <button type="button" class="btn btn-link w-100 mt-2" onClick={() => setOtpToken(null)}>
                    Back to Email
                  </button>
                </form>
              }>
                <form onSubmit={handleSendOtp}>
                  <div class="mb-3">
                    <label class="form-label">Email address</label>
                    <input
                      type="email"
                      class="form-control"
                      value={email()}
                      onInput={(e) => setEmail(e.currentTarget.value)}
                      disabled={isLoading()}
                      required
                    />
                  </div>
                  <button type="submit" class="btn btn-primary w-100" disabled={isLoading()}>
                    {isLoading() ? <Loader /> : 'Send OTP'}
                  </button>
                </form>
              </Show>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SignInPage
